<template>
	<div class="gk_editor">
		<div class="filter-tag-row">
			<ReFilterBtn v-model="bShowFilter" :bShowOptsCount="false"/>
			<span class="ml-3 el-tag el-tag--small el-tag el-tag--plain el-tag--primary">Элементов: {{this.masObjects_total}}</span>
		</div>		
		<div class="col-md-12" v-show="bShowFilter">
			<ReFilter :masAllFilterParams="masAllFilterParams" 
			v-model="objGetParams" 
			v-on:filterapply="OnFilterApply"
			name="gkedit"/>
		</div>

		<!-- <pre>{{ApiData}}</pre> -->

		<card>
			<el-table ref="multipleTable" 
				:data="ApiData"
				v-loading.fullscreen.lock="$GVO.fullscreenLoading"
				element-loading-text="Загрузка данных..."
				element-loading-spinner="el-icon-loading"
				element-loading-background="rgba(0, 0, 0, 0.8)"	
				>
			<!-- <el-table ref="multipleTable" 
				:data="ApiData"
				@expand-change="rowClicked"
				@row-click="expandRow"
				:row-key="row => row.dev_name_tr+'_'+row.gk_name_tr"	
				:expand-row-keys="expandRowKeys"
				> -->
				<!-- <el-table-column 
					type="expand" 							
					sortable
					property="gk_name_tr"
					>
					<template slot-scope="ApiData">
						<div>
								{{ ApiData.row.block_tree}}
						</div>

						
					
					</template>
				</el-table-column> -->
				<el-table-column
					width="80"
					label="Ind"
					type="index"
				></el-table-column>			
				<el-table-column
					width="280"
					label="block_tree"
					type="block_tree"
				>
					<template v-slot="scope">
						{{ scope.row.block_tree}}
					</template>
				</el-table-column>			
				<el-table-column
					min-width="55"
					sortable
					label="Застройщик"
					property="dev_name"
				></el-table-column>			
				<el-table-column
					min-width="140"
					sortable
					label="Комплекс"
					property="gk_name"
				></el-table-column>			
				<el-table-column
					min-width="155"
					label=""
					property="gk_name_tr"
					align="right"
				>
					<template v-slot="scope">
						<base-button type="primary" class="my-0" simple @click="GoToGk(scope.row.gk_name_tr)">Редактировать</base-button>
					</template>
				</el-table-column>
					
			</el-table>
			
		</card>
		<Pagination v-if="bIsObjects" :class="[{'': parseInt(masObjects_total) > 0}, {'d-none': parseInt(masObjects_total) < 1}]"
			:type="'info'" 
			:total="parseInt(masObjects_total)" 
			:perPage="parseInt(count2page)"
			:value="parseInt(typeof objGetParams.p == 'undefined' ? 1:objGetParams.p)"
			:pClick="pClick">
		</Pagination>	
	</div>
</template>
<script>
import {eventEmitter} from "src/plugins/globalComponents.js";
import { Table, TableColumn, Button } from 'element-ui';
// import { BaseSwitch } from 'src/components/index';
import ReFilterBtn from 'src/our_components/FilterPrinter/ReFilterBtn.vue';
import ReFilter from 'src/our_components/FilterPrinter/ReFilter.vue';
import Pagination from 'src/our_components/RePagination';

export default {
	name: 'gk_editor-page',
	components: {
		// BaseSwitch,
		[Table.name]: Table,
		[TableColumn.name]: TableColumn,
		[Button.name]: Button,
		ReFilterBtn,
		ReFilter,
		Pagination,
	},
	props: {
		counter: String,
		findId: { //это свойсво удалять не надо, оно хорошее и моет быть использовано в опуиях для формпринтера или фильтрпринтера
			type: String,
			default: '',
		},
	},
	data() {
		return {
			ApiData: [],
			bShowFilter: false,
			masAllFilterParams: this.currentFilterConfig(),
			bIsObjects: true,
			dSearchType: 'complex',
			dSortType: 'dt_upd|d',
			masObjects_total: 0,
			count2page: 10,
			fullscreenLoading: false,
			objGetParams: {},
			expandRowKeys: [],
		};
	},
	methods: {
		getApiData(){
			this.ApiData = [];
			this.objGetParams = this.$GVO.GetAllGet();
			let filter = {};
			// if (!this.$GVO.isEmpty(this.objGetParams)) {
			// 	if(typeof this.objGetParams.dSearchType !='undefined') this.dSearchType = this.objGetParams.dSearchType;
			// 	filter = this.$GVO.SafeParseJson(JSON.stringify(this.objGetParams));				
			// }
			if (!this.$GVO.isEmpty(this.objGetParams)) {
				//console.log('getApi',this.objGetParams);
				filter = this.objGetParams;
			}
			// {"obj":"NovoObj","flt":{"dSearchType":"complex","dSortType":"dt_upd|d","dSortOrder":"d","AddComplexMinFlatsBig":"1","dnotworkgk":"0"}}
			this.$GVO.ApiCall('GET_COMPLEX_LIST_FOR_EDIT',{obj:'NovoObj',flt:{'list':true,...filter}})
			//this.$GVO.ApiCall('GET',{obj:'NovoObj',flt:{"dSearchType":"complex","dSortType":"dt_upd|d","dSortOrder":"d",...filter}})
			// this.$GVO.ApiCall('GET',{obj:'DEV',flt:{...filter, 'list':true}}) // 'GetMyDevExtraData',{obj:'DEV' ,flt:{}}
			.then((objApi) => {
				if(objApi.success === true){
					if(objApi.data.length > 0){
						// console.log(objApi.data);
						this.ApiData = objApi.data;//.map(v=>((v.private=v.public=='0'),v));
					}
					if(objApi.total!=undefined) {this.masObjects_total=objApi.total;}
				}else {
					this.ApiData = [];
					this.masObjects_total=0;
				}
			}).catch(errorObjApi => {this.ApiData = []; this.masObjects_total=0; console.error(errorObjApi);});
		},
		// setPrivate(row){
		// 	//row.private=!row.private;
		// 	this.$GVO.ApiCall('SetGKExcludeList',{obj:'DEV',flt:{},iData:{PK:row.PK,public:row.public}})
		// 		.then(objApi=>{
		// 			if(objApi.success === true && objApi.data){
		// 				// выставить комплексу признак посел сохранения в базе
		// 				row.public=objApi.data.public;
		// 				//me.ApiData.some(d=>(d.PK==PK)?((d.private=objApi.data.private),console.log(d,objApi.data),true):false)
		// 			}					
		// 		})
		// },
		// setExport(row){
		// 	this.$GVO.ApiCall('SetGKExportList',{obj:'DEV',flt:{},iData:{PK:row.PK,export_exclude:row.export_exclude}})
		// 		.then(objApi=>{
		// 			if(objApi.success === true && objApi.data){
		// 				// выставить комплексу признак после сохранения в базе
		// 				row.export_exclude=objApi.data.export_exclude;
		// 			}					
		// 		})
		// },
		// setPriority(row){
		// 	this.$GVO.ApiCall('SetGKPriority',{obj:'DEV',flt:{},iData:{PK:row.PK,priority:row.priority}})
		// 		.then(objApi=>{
		// 			if(objApi.success === true && objApi.data){
		// 				// выставить комплексу признак после сохранения в базе
		// 				row.priority=objApi.data.priority;
		// 			}					
		// 		})
		// },
		currentFilterConfig(){
			this.$GVO.ApiCall('GET_FILTER_GK',{obj:'NovoObj'})
			.then((objApi) => {
				//console.log(objApi);
				if(objApi.success){
					this.masAllFilterParams = objApi.config;
					eventEmitter.$emit('OnFilterConfigLoad', this.masAllFilterParams);
				}
			})
			.catch(errorObjApi => console.error(errorObjApi));
			return [];
		},
		// OnFilterApply(strItogGetParams){ // применяет параметры из фильтра и запускает запрос к АПИ
		// 		if(strItogGetParams == undefined){
		// 			let objItogGetParams = this.$GVO.GetAllGet();
		// 			if(typeof objItogGetParams.dSearchType !='undefined' && this.dSearchType != objItogGetParams.dSearchType) {
		// 				objItogGetParams.dSearchType = this.dSearchType;
		// 				if(typeof objItogGetParams['p'] != 'undefined'){
		// 					delete objItogGetParams['p'];
		// 				}
		// 			}
		// 			strItogGetParams = this.$GVO.ObjToQueryString(objItogGetParams).substr(1);
		// 		}
		// 		console.log('OnFilterApply',strItogGetParams);
		// 		this.$router.push({path: location.pathname+'?'+strItogGetParams});
		// 		this.getApiData();
		// 	},
		OnFilterApply(data){
			// console.log('OnFilterApply',data);
			//console.log('OnFilterApply',this.objGetParams);
			if(typeof data != 'undefined' && typeof this.objGetParams['p'] != 'undefined'){
				delete this.objGetParams['p'];
			}

			for (const key in this.objGetParams) {
				if (Object.hasOwnProperty.call(this.objGetParams, key)) {
					if(this.objGetParams[key] == '') delete this.objGetParams[key];
				}
			}
			let strItogGetParams = this.$GVO.ObjToQueryString(this.objGetParams).substr(1);
			//console.log('OnFilterApply',strItogGetParams,this.objGetParams);
			this.$router.push({path: location.pathname+'?'+strItogGetParams});
			eventEmitter.$emit('OnFilterApply', this.objGetParams);
			this.getApiData();
		},
		pClick(e){
			this.objGetParams['p'] = parseInt(e);
			this.OnFilterApply();
		},
		GoToGk(rowData){
			//location.href = `/data/ColdCall/id/${rowData.id}`; 
			this.$router.push({path: `/data/settings/gk_editor/id/${rowData}`});
			// console.log(rowData);
		},
		rowClicked(row, expandedRows) {
			const id = row.id;
			const lastId = this.expandRowKeys[0];
			// disable mutiple row expanded 
			this.expandRowKeys = id === lastId ? [] : [id];
			
			if(expandedRows !='') {
				// this.getCall(row.RecID);
				// console.log(row.block_tree);
			} //else {this.strAudioLink ='';}
		},
		expandRow (row, event, column) {
			this.$refs.tableData.toggleRowExpansion(row);
		},
		tableRowClassName({row, rowIndex}) {
			if(row.block_tree == '') {
				// console.log(objApi);
				return 'row-expand-cover';
			} else {
				return 'row-expand-hover';
			}
		},
		// pClick(e){
		// 	let strItogGetParams = '';
		// 	let objItogGetParams = this.$GVO.GetAllGet();
		// 	objItogGetParams.p=parseInt(e);
		// 	strItogGetParams = this.$GVO.ObjToQueryString(objItogGetParams).substr(1);
		// 	this.OnFilterApply(strItogGetParams);

		// },
	},
	mounted() {
			// var queryParams = new URLSearchParams(window.location.search);
			// queryParams.set("dSearchType", "complex");
			// history.replaceState(null, null, "?"+queryParams.toString());

			this.objGetParams = this.$GVO.GetAllGet();
			// if(typeof this.objGetParams.dSearchType !='undefined') this.dSearchType = this.objGetParams.dSearchType;
			this.getApiData();

		// this.getApiData();
	}
};
</script>
<style scoped>
</style>
